import JSAlert from 'js-alert'

export default class Base {
    ajaxUrl
    nonce
    JSAlert
    constructor() {
        this.nonce = archm_admin.nonce
        this.ajaxUrl = archm_admin.ajax_url
        this.JSAlert = JSAlert
    }

    alertSuccess(data){
        JSAlert.alert(data.title, null, JSAlert.Icons.Success);
    }

    alertError(data){
        JSAlert.alert(data.title, null, JSAlert.Icons.Failed);
    }

}